// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__1AQVA","fadein":"Modal_fadein__2Ds3Y","modalContent":"Modal_modalContent__2EsRO"};